<template>
	<div :class="'tgju-widgets-block ' + col "> 
		<div class="mb-3 pb-3 pt-3">
			<span class="float-left pl-1">
				{{ posts.total }} نظر
				<a v-if="!user && auth == 'show'" @click="open_login_modal" class="pr-3">
					<i class="fa fa-sign-in"></i>ورود - ثبت نام
				</a>
			</span>
			<div class="float-right pr-1" style="margin-top: -8px;">
				<a @click="sort('best')" class="pl-3">
					<i class="sort-icon-i uil uil-thumbs-up"></i> محبوب‌ترین‌ها
				</a>
				<a @click="sort('old')" class="pl-3">
					<i class="sort-icon-i uil uil-sort-amount-up"></i> قدیمی‌ترین‌ها
				</a>
				<a @click="sort('new')" class="pl-3">
					<i class="sort-icon-i uil uil-sort-amount-down"></i> جدیدترین‌ها
				</a>
			</div>
		</div>

		<!-- فرم ارسال توییت -->
		<PostSend v-if="user && sendbox == 'enabled' " :newPost="newPost" ref="post-postSend"></PostSend>


		<slot v-if="widgetLoad">
			<div v-if="widgetLoad" class="tgju-widget light post mb-3">
				<div class="text-center p-2">
					<div class="widget-loading"></div>
				</div>
			</div>
		</slot>
		<slot v-else>

			<!-- پست -->
			<template v-if="posts.data.length">
				<div class="tgju-widget light post mb-3" v-for="post in posts.data" :key="post.id">
					<div class="post-row">
						<PostItem :post="post" :subject="subject" :title="title"></PostItem>
					</div>
				</div>
				<div class="tgju-widget light border-0  post mb-3">
					<div v-if="posts.last_page > 1" class="p-5 d-flex justify-content-center">
						<Paginate :page-count="posts.last_page" :click-handler="loadData" :prev-text="'قبل'" :next-text="'بعد'" :container-class="'pagination'" ></Paginate>
					</div>
				</div>

			</template>

			<template v-else>
				<div class="tgju-widget light post mb-3">
					<div class="no-content d-flex justify-content-center">
						<div class="text-center p-2">
							<div class="not-found-items">
								<i class="uil uil-comment-alt-slash"></i><br> 
								در این کانال تا کنون دیدگاهی به ثبت نرسیده است.
								<br>
								شما اولین دیدگاه را ثبت کنید.
							</div>
						</div>
					</div>
				</div>
			</template>

		</slot>
	</div>
</template>

<style lang="scss">
		.textarea-post {
			padding: 10px;

			&:focus {
				outline: 0;
			}

			.emoji {
				width: 20px;
			}
		}

		.post .no-content {
			padding: 20px 15px;
			font-size: 13px;
		}

		#popper-button {
			position: relative;
			top: -4px;
		}

		#btn-emoji-default {
			margin: 0 !important;
			padding: 0 !important;
			width: 30px !important;
			height: 22px !important;
		}

		#btn-emoji-default > div > img.emoji {
			height: 20px !important;
			width: 20px !important;
		}

		#emoji-container > #emoji-popup img.emoji {
			height: 21px !important;
			width: 21px !important;
		}

		#emoji-container > #emoji-popup #emoji-popover-search > #search-header > span {
			padding: 10px 10px !important;
		}

		#emoji-container > #emoji-popup #emoji-popover-search > #search-header > input {
			font-size: 14px !important;
		}

		#popper-container {
			z-index: 9999 !important;
		}

		#popper-container #arrow {
			display: none !important;
		}

		#emoji-container > #emoji-popup .emoji-popover-inner {
			margin-right: -4px !important;
		}

		#emoji-container > #emoji-popup .emoji-popover-inner > div > .emoji-list > span {
			font-size: 8px !important;
		}

		.textarea-post .emoji {
			margin-right: 4px;
		}

		.profile-post-content .emoji {
			width: 17px;
			margin-right: 3px;
		} 
		
		.profile-post-content .post-img {
			max-width: 100%;
			margin-top: 20px;
		}

		.left-menu-dropdown {
			display: block !important;
		}

	.user-block-reshare {
		margin: 20px;
		display: block;
		background-color: #fff;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.03) !important;
		border-radius: 6px !important;
		border: 1px solid #dee2e6;

		.tgju-widget-content {
			padding: 6.4px 20px 10px;
		}

		.user-block-avatar {
			width: 35px;
			height: 35px;
		}

		.post-btn-row {
			display: none;
		}

		.reshare-label {
			text-align: center;
			color: #676767;
			white-space: nowrap;
			display: flex;
			align-items: center;
			padding: 9px 15px;
			justify-content: start;
			border-bottom: 1px solid #ccc;

			i {
				font-size: 18px;
				line-height: 0;
				position: relative;
				margin-left: 5px;
				top: 1px;
			}

			.text {
				font-size: 11px;
			}
		}
	}

		.emoji-mart {
			z-index: 99999999;
			position: absolute;
			left: 45px;
		}

		.vue-popover-theme {
			z-index: 999;

			.tooltip-inner {
				border-radius: 5px;
				padding: 6px;
				box-shadow: rgba(0, 0, 0, 0.1) 0px 5px 12px;
				background: rgb(249, 249, 249);
			}

			.mention-item {
				padding: 3px 7px;
				cursor: pointer;
				border-radius: 5px;

				&.mention-selected {
					background: rgb(0, 123, 255);
					color: #fff;
				}
			}
		}
	</style>

<script>
	import PostSend from '@/components/TgjuPosts/PostSend.vue'
	import PostItem from '@/components/TgjuPosts/PostItem.vue'
	import Paginate from "vuejs-paginate";

	export default {
		name: 'TgjuPost',
		components: {
			PostSend,
			PostItem,
			Paginate,
		},
		props: ['subject', 'col','type' , 'auth', 'username', 'sendbox', 'title'],
		data: function () {
			return {
				newPost: {
					content: '',
					type: 'tgju-post',
					parent_id: 0,
					subject: this.subject,
					attachments: [],
				},
				posts: {
					length:undefined,
					current_page: undefined,
					from: undefined,
					last_page: undefined,
					next_page_url: undefined,
					per_page: undefined,
					prev_page_url: undefined,
					to: undefined,
					total: undefined,
					data : {
						length:undefined,
					}
				},
				user : this.$helpers.userSync(),
				sort_value : 'new',
				widgetLoad: true,
			}
		},

		mounted() {
			this.loadData();
		},

		methods: {
			loadData(page) {
				let api_data = {
					subject : this.subject,
					username : this.username == "" ? 'everybody' : this.username,
					sort :  this.sort_value,
					page : page ? page : 1,
				};

				if(this.type != 'widget'){
					$("body").append(`
						<style>
							footer , header , .list-box-index , .index-row-items , bar-menu-dashboard-box
							.bar-menu , .footer-quickview , .mobile-hide , .bottom-left-ad , .bottom-right-ad , .bar-menu-dashboard-box {
								display: none !important;
							}

							body {
								margin: 0px !important;
								padding: 0px !important;
								background: white !important;
							}

							.widgets {
								border: none !important;
							}
						</style>
					`);
				}
						
				this.$helpers.makeRequest('GET', '/tgju-post/list', api_data).then(api_response => {
					this.$helpers.api_alert(api_response);

					if ( api_response.status == 200 ) {
						let response = api_response.data.response;
						this.posts = response.posts;
						this.widgetLoad = false;
					}
				});

			},

			setCaretToEnd() {
				let postSendComponent = this.$refs['post-postSend'];
				postSendComponent.setCaretToEnd(postSendComponent.$refs['textarea-post']);
			},

			scrollTo(container) {
				let postSendComponent = this.$refs['post-postSend'];
				postSendComponent.scrollTo(container);
			},

			sort(value) {
				this.sort_value = value;
				this.loadData();
			},

			open_login_modal() {

				if ($('#auth-modal').length) {
					$('#auth-modal').toggle();
				} else {
					window.Auth.set_api_domain(process.env.VUE_APP_API_URL);
					window.Auth.load();
				}
			},
		}
	}
</script>
